import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-delete",
  "use": "svg_i-delete-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 12\" id=\"svg_i-delete\"><path d=\"M9 3v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3\" stroke=\"currentColor\" stroke-width=\"2\" /><rect y=\"1\" width=\"11\" height=\"2\" rx=\"1\" fill=\"currentColor\" /><path d=\"M3 1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2H3V1Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol